import { render, staticRenderFns } from "./checklist.vue?vue&type=template&id=023a6e5b&scoped=true"
import script from "./checklist.vue?vue&type=script&lang=js"
export * from "./checklist.vue?vue&type=script&lang=js"
import style0 from "./checklist.vue?vue&type=style&index=0&id=023a6e5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023a6e5b",
  null
  
)

export default component.exports